/* loaded by smart-asset */
export default require("./keyboard_arrow_down-24px~ZwVifpJr.svg")